import { useState } from 'react'
import {
  HeartIcon,
  BeakerIcon,
  FingerPrintIcon,
  ScaleIcon,
  SearchIcon,
  SparklesIcon,
  ShieldCheckIcon,
  ZoomInIcon,
  PhotographIcon,
} from '@heroicons/react/outline'

import './index.css'

const icons = {
  HeartIcon,
  BeakerIcon,
  FingerPrintIcon,
  ScaleIcon,
  SearchIcon,
  SparklesIcon,
  ShieldCheckIcon,
  ZoomInIcon,
  PhotographIcon,
}

export default function ServiceCard({ service, shouldTruncate }) {
  const [readMore, setReadMore] = useState(false)
  const Icon = icons[service.icon] || HeartIcon

  const numberOfChars = 120
  const isLong = service.description.length > numberOfChars
  const firstFewCharacters = service.description.substring(0, numberOfChars)
  const extraContent = service.description.substring(numberOfChars, service.description.length)

  return (
    <div className="flex flex-col rounded-xl overflow-hidden bg-white shadow-md hover:shadow-xl transition-shadow duration-200 border border-gray-100">
      <div className="flex items-center justify-center h-32 bg-gradient-to-br from-primary-700 to-accent-600">
        <span className="flex items-center justify-center h-16 w-16 rounded-full bg-white/15">
          <Icon className="h-8 w-8 text-white" />
        </span>
      </div>
      <div className="flex flex-col flex-1 px-5 py-5">
        <h3 className="font-bold text-lg text-primary mb-2">{service.name}</h3>
        {shouldTruncate && isLong ? (
          <>
            <p className="text-gray-600 text-sm leading-relaxed">
              {firstFewCharacters}
              {!readMore && '…'}
              {readMore && extraContent}
            </p>
            <button
              type="button"
              onClick={() => setReadMore(!readMore)}
              className="mt-2 self-start text-accent-600 hover:text-accent-700 text-sm font-semibold"
            >
              {readMore ? 'Read less' : 'Read more'}
            </button>
          </>
        ) : (
          <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
        )}
        <div className="mt-4 flex flex-wrap gap-2">
          {service.tags.map((tag) => (
            <span
              key={tag}
              className="inline-block bg-primary-50 text-primary-700 rounded-full px-3 py-1 text-xs font-semibold"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}
